import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-bf5cb248")

_pushScopeId("data-v-bf5cb248")
const _hoisted_1 = { class: "flex flex-col gap-y-3 w-full h-full" }
const _hoisted_2 = { class: "w-full h-full" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_HeaderUpdate = _resolveComponent("HeaderUpdate")!
  const _component_SearchFilter = _resolveComponent("SearchFilter")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_EmptyList = _resolveComponent("EmptyList")!
  const _component_NotFoundState = _resolveComponent("NotFoundState")!
  const _component_SummaryInfo = _resolveComponent("SummaryInfo")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!

  return (_openBlock(), _createBlock(_component_DetailLayout, {
    onBack: _ctx.goBack,
    title: _ctx.$t('dispatch.dispatchDelivery'),
    "vertical-separator": false,
    fullPage: "",
    usePaddingVertical: false,
    customClass: "pr-0"
  }, {
    data: _withId(() => [
      _createVNode(_component_HeaderUpdate, {
        "dem-status": _ctx.demStatus,
        "scan-data": _ctx.lastScanData?.dtScanNo ? [_ctx.lastScanData] : [],
        onScan: _ctx.updateScan,
        scanFailedList: _ctx.listSttFailed
      }, null, 8, ["dem-status", "scan-data", "onScan", "scanFailedList"]),
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_SearchFilter, {
          searchValue: _ctx.form.q,
          disabled: !_ctx.temporaryList.data?.length,
          onSearch: _ctx.onSearch,
          onClearSearch: _ctx.onClearSearch,
          onProcess: _ctx.onProcess,
          onCourierShuttleChange: _ctx.onCourierShuttleChange
        }, null, 8, ["searchValue", "disabled", "onSearch", "onClearSearch", "onProcess", "onCourierShuttleChange"]),
        (_ctx.isEmptyList)
          ? (_openBlock(), _createBlock(_component_EmptyState, { key: 0 }))
          : (_ctx.isErrorList)
            ? (_openBlock(), _createBlock(_component_EmptyList, {
                key: 1,
                "button-action": _ctx.buttonActionError,
                onAction: _ctx.getList,
                icon: _ctx.form.errorData?.image,
                customHeaderMessage: _ctx.form.errorData?.title,
                customMessage: _ctx.form.errorData?.message,
                customClassImage: "w-44"
              }, null, 8, ["button-action", "onAction", "icon", "customHeaderMessage", "customMessage"]))
            : (_ctx.isNotFound)
              ? (_openBlock(), _createBlock(_component_NotFoundState, { key: 2 }))
              : (_openBlock(), _createBlock(_Fragment, { key: 3 }, [
                  _createVNode(_component_SummaryInfo, _ctx.summaryData, null, 16),
                  _createVNode("div", _hoisted_2, [
                    _createVNode(_component_TableV2, {
                      columns: _ctx.columns,
                      data: _ctx.listSttSuccess,
                      loading: _ctx.temporaryList.loading,
                      isShowPagination: false
                    }, null, 8, ["columns", "data", "loading"])
                  ])
                ], 64))
      ])
    ]),
    _: 1
  }, 8, ["onBack", "title"]))
})